import * as React from "react";

const { useState } = React;
import { ActionButton } from "../../components/ActionButton/ActionButton";
import { useContext } from "react";
import { ProposalsContext } from "./ProposalsContext";
import { ErrorMessage } from "./ErrorMessage";
import { apiPost } from "./util";
import { ISitrepProposal, IProposalLists } from "./interfaces";

// @ts-ignore
import css from "./finalized-proposals.module.scss";
// @ts-ignore
import commonCss from "./common.module.scss";


export const FinalizedProposals: React.FC<{}> = () => {

    const [ error, setError, ] = useState<string>();
    const [ showFinalized, setShowFinalized ] = useState<boolean>(true);

    const { updateLists, lists: { finalized: list, }, } = useContext(ProposalsContext);

    async function unfinalize(proposal: ISitrepProposal) {
        try {
            const lists = await apiPost<IProposalLists>("/unfinalize", {
                logId: proposal.logId,
                masterEventId: proposal.masterEventId,
            });
            updateLists(lists);
        } catch (err) {
            setError(err.message);
        }
    }

    if (!(list && list.length)) {
        return null;
    }
    return (
        <div className={ commonCss.proposalsSectionWrapper }>
            <h3>Approved and finalized</h3>
            <label className={ css.visibilityToggler }>
                <input type="checkbox" checked={ showFinalized } onChange={ () => setShowFinalized(!showFinalized) } />
                Show { list.length } proposal{ 1 == list.length ? "" : "s" }
            </label>
            <ErrorMessage message={ error }/>
            {
                showFinalized &&

                <dl className={ css.finalizedItems }>
                    {
                        list && list.map((proposal) => {
                            const {
                                logId, masterEventId,
                                agentId, agentName,
                                eventLocation, eventName,
                                handledTs, handledBy, handledByName,
                            } = proposal;
                            const eventFullName = `${ eventName } ${ eventLocation }`;
                            return (
                                <>
                                    <dt key={ logId }>
                                        <a href={ `/r/?page=event&id=${ masterEventId }` }>{ eventFullName }</a>
                                        <ActionButton type="normal" onClick={ () => unfinalize(proposal) }
                                            label="Unfinalize"/>
                                    </dt>
                                    <dd>
                                        <a href={ `/r/?page=log&logid=${ logId }` }>Log entry</a>
                                        { " " }by{ " " }
                                        <a href={ `/r/?page=profile&id=${ agentId }` }>{ agentName }</a>
                                    </dd>
                                    <dd className={ commonCss.handledInfo }>
                                        Handled by <a
                                        href={ `/r/?page=profile&id=${ handledBy }` }>{ handledByName }</a> at { handledTs }
                                    </dd>
                                </>
                            );
                        })
                    }
                </dl>
            }
        </div>
    );
};
